export const STEP_RESTART_TRANSITION_DELAY_MS = 300;
